import axios from 'axios';

const adminAPI = axios.create({
  baseURL: 'https://api.yibeworld.com/api/v1',
  withCredentials: true,
});

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

adminAPI.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase();
  if (method && ['post', 'put', 'patch', 'delete'].includes(method)) {
    const token = getCookie('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
  }
  return config;
});

// Auth
export const adminLogin = (username: string, password: string) =>
  adminAPI.post('/site/auth/login/', { username, password });

export const adminLogout = () =>
  adminAPI.post('/site/auth/logout/');

export const adminCheckAuth = () =>
  adminAPI.get('/site/auth/check/');

// Site Settings
export const getSettings = () =>
  adminAPI.get('/site/admin/settings/');

export const updateSettings = (data: Record<string, string>) =>
  adminAPI.put('/site/admin/settings/', data);

// Navigation
export const getNavItems = () =>
  adminAPI.get('/site/admin/nav/');

export const createNavItem = (data: Record<string, unknown>) =>
  adminAPI.post('/site/admin/nav/', data);

export const updateNavItem = (id: number, data: Record<string, unknown>) =>
  adminAPI.put(`/site/admin/nav/${id}/`, data);

export const deleteNavItem = (id: number) =>
  adminAPI.delete(`/site/admin/nav/${id}/`);

// Products
export const getAdminProducts = () =>
  adminAPI.get('/admin/products/');

export const createProduct = (data: FormData) =>
  adminAPI.post('/admin/products/', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateProduct = (id: number, data: FormData) =>
  adminAPI.put(`/admin/products/${id}/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteProduct = (id: number) =>
  adminAPI.delete(`/admin/products/${id}/`);

// Categories
export const getAdminCategories = () =>
  adminAPI.get('/admin/categories/');

export const createCategory = (data: Record<string, unknown>) =>
  adminAPI.post('/admin/categories/', data);

export const updateCategory = (id: number, data: Record<string, unknown>) =>
  adminAPI.put(`/admin/categories/${id}/`, data);

export const deleteCategory = (id: number) =>
  adminAPI.delete(`/admin/categories/${id}/`);

// Currencies
export const getCurrencies = () =>
  adminAPI.get('/site/admin/currencies/');

export const createCurrency = (data: Record<string, unknown>) =>
  adminAPI.post('/site/admin/currencies/', data);

export const updateCurrency = (id: number, data: Record<string, unknown>) =>
  adminAPI.put(`/site/admin/currencies/${id}/`, data);

export const deleteCurrency = (id: number) =>
  adminAPI.delete(`/site/admin/currencies/${id}/`);

export const refreshRates = () =>
  adminAPI.post('/site/admin/rates/refresh/');

export default adminAPI;
